export default __webpack_public_path__ + "static/story_headphones-6e0f014aebb30d51acff99b457a97921.mp4";